<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <form-group label="Categoria" :columns="3" :required="true" :error="getError('category', product.productId)">
      <select v-model="categorySelected" class="form-select">
        <option v-for="category in categories" :value="category.code">{{ category.label }}</option>
      </select>
    </form-group>

    <form-group label="Categoria de nível 2" :columns="3" :required="true" v-if="categorySelected !== null && childCategories.length > 0" :error="getError('childCategorySelected', product.productId)">
      <select v-model="childCategorySelected" class="form-select">
        <option v-for="childCategory in childCategories" :value="childCategory.code">{{ childCategory.label }}</option>
      </select>
    </form-group>

    <form-group label="Certificações" :columns="3" :required="true" :error="getError('certification', product.productId)">
      <select v-model="product.certification" class="form-select">
        <option v-for="certification in certificationOptions" :value="certification">{{ certification }}</option>
      </select>
    </form-group>

    <form-group label="Código de certificações" :columns="3">
      <input class="form-input" type="text" v-model="product.certificationCode">
    </form-group>


    <form-group label="Itens inclusos" :columns="3" :required="true" :error="getError('includedItems', product.productId)">
      <input class="form-input" type="text" v-model="product.includedItems">
    </form-group>
  </shared-product-provide>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'carrefour'
      },
      maxDescriptionLengthDI: null,
      allowDescriptionHtml: false
    },
    data: () => ({
      loadingCategories: false,
      categories: [],
      categorySelected: null,
      certification: null,
      certificationCode: null,
      includedItems: null,
      childCategorySelected: null,
      childCategories: [],
      certificationOptions: [
        'ANATEL',
        'ANVISA',
        'INMETRO',
        'MAPA',
        'Não Informada',
        'Não Se Aplica'
      ]
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$parent.loadingProducts(false)

      this.loadingCategories = true
      api.getCategories('marketplace', 'carrefour')
        .then(categories => {
          this.categories = categories
        })
        .catch(() => {
          notifier.error('Impossível carregar as categorias do Carrefour.', 'Erro')
        })
        .finally(() => {
          this.loadingCategories = false
        })
    },
    watch: {
      categorySelected (value) {
        api.getCategories('marketplace', 'carrefour', value)
          .then(childCategories => {
            this.childCategories = childCategories
          })
          .catch(() => {
            notifier.error('Impossível carregar as categorias do Carrefour.', 'Erro')
          })
          .finally(() => {
            this.loadingCategories = false
          })
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        if (!this.product.certification || this.product.certification === '') {
          this.addError({
            productId: this.product.productId,
            property: `certification`,
            sku: this.product.id,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (!this.product.includedItems || this.product.includedItems === '') {
          this.addError({
            productId: this.product.productId,
            property: `includedItems`,
            sku: this.product.id,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (this.categorySelected) {
          this.product.category = this.categorySelected
        }

        if (this.childCategorySelected) {
          this.product.category = this.childCategorySelected
        }

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            return {
              sku: variation.sku,
              title: this.product.title,
              category: this.product.category,
              description: this.product.description,
              stock: variation.stock,
              price: variation.price,
              source: this.fromModule,
              ean: variation.ean,
              images: variation.images.length ? variation.images : null,
              width: variation.width,
              height: variation.height,
              weight: variation.weight,
              length: variation.length,
              brand: this.product.brand,
              productId: this.product.productId,
              certification: this.product.certification,
              certificationCode: this.product.certificationCode,
              includedItems: this.product.includedItems,
              crossDocking: {
                quantity: variation.crossDocking
              },
              color: variation.attributes['color'],
              gridType: this.getType(variation),
              grid: this.getGrid(variation),
              original: {
                product: this.product,
                variation: variation
              }
            }
          })
      },
      getType (variation) {
        let type

        if (variation.attributes['size']) {
          type = 'size'
        }

        if (variation.attributes['voltage']) {
          type = 'voltage'
        }

        return type
      },
      getGrid (variation) {
        let grid

        if (variation.attributes['voltage']) {
          grid = variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          grid = variation.attributes['size']
        }

        return grid
      }
    },
    components: {
      SharedProductProvide,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?925017b2